import { type MaskitoOptions, maskitoUpdateElement } from '@maskito/core';
import { maskitoEventHandler, maskitoNumberOptionsGenerator } from '@maskito/kit';

export const TOTAL_MONTHLY_INCOME_TOOLTIP_MESSAGE =
  'Alimony, child support, or separate maintenance income need not be disclosed if you do not wish to have it considered as a basis for repaying this obligation.';

export const TOTAL_MONTH_INCOME_MAX_LENGTH = 8;

export const TOTAL_MONTHLY_INCOME_PREFIX = '$';

const numberOptions = maskitoNumberOptionsGenerator({
  thousandSeparator: ',',
  min: 0,
  prefix: TOTAL_MONTHLY_INCOME_PREFIX,
});

export const TOTAL_MONTHLY_INCOME_MASK_OPTIONS: MaskitoOptions = {
  ...numberOptions,
  plugins: [
    ...numberOptions.plugins,
    maskitoEventHandler('input', (element) => {
      if (element.value === TOTAL_MONTHLY_INCOME_PREFIX) {
        maskitoUpdateElement(element, '');
      }
    }),
  ],
};
